import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT, redMui } from "@ryde/theme";

export const PanelTopRightStatItemWrapper = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "panel-top-right-stat-item-wrapper",
  },
)`
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 14px;
  margin-inline-end: 5px;
  font-weight: 400;
  span {
    font-size: 11px;
    line-height: 13px;
    vertical-align: middle;
  }
  label {
    margin-inline-start: 3px;
    align-items: center;
    display: flex;
    &.error {
      color: ${redMui._800};
    }
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-inline-end: 3px;
    font-size: 13px;
    font-weight: 400;
    label {
      margin-inline-start: 0;
    }
  }
`;

export const ProduceButtonsPanelTopItemsWrapper = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "produce-buttons-panel-top-items-wrapper",
  },
)`
  height: 30px;
  padding-inline-start: 20px;
  padding-inline-end: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  margin-inline-end: auto;
`;
